/* eslint no-console: 0 */
import firebaseRef from './firebaseRef';

class PromoCode {
  constructor(code, promo) {
    this._code = code;
    this._promo = promo;
  }

  get code() {
    return this._code;
  }

  get value() {
    return this._promo.value;
  }

  isAvailable() {
    return this._promo.available > 0;
  }

  isValidForProgram(programId) {
    if (this._promo.programs === 'all') return true;
    return (this._promo.programs[programId]);
  }
}

const PROMOCODE_REGEX = /^[A-Z0-9\-]+$/;

export function isValidFormat(promoCode) {
  return PROMOCODE_REGEX.test(promoCode);
}

export function fetch(promoCode) {
  return new Promise((resolve, reject) => {
    if (!PROMOCODE_REGEX.test(promoCode)) return resolve();
    firebaseRef.child('promoCodes')
      .child(promoCode)
      .once('value', snapshot => {
        const val = snapshot.val();
        if (!val) return resolve(null);
        resolve(new PromoCode(promoCode, val));
      }, reject);
  });
}

export function decreaseAvailable(promoCode) {
  return new Promise((resolve, reject) => {
    if (!PROMOCODE_REGEX.test(promoCode)) return reject(new Error('Invalid format for promo-code.'));
    firebaseRef
      .child('promoCodes').child(promoCode).child('available')
      .transaction(
        currentValue => (currentValue || 0) - 1,
        err => {
          if (err) return reject(err);
          resolve();
        });
  });
}

export default {
  fetch: fetch,
  decreaseAvailable: decreaseAvailable,
  isValidFormat: isValidFormat
};



// WEBPACK FOOTER //
// ./src/services/promoCode.js